import * as Yup from "yup";

const email = Yup.string()
  .email("Invalid email address")
  .min(8, "Must be 8 characters at minimum")
  .max(254, "Must be 254 characters or less")
  .lowercase()
  .trim()
  .required();
const phone = Yup.string()
  .min(8, "Must be 8 characters at minimum")
  .max(12, "Must be 12 characters or less")
  .lowercase()
  .trim()
  .required();
const name = Yup.string()
  .min(3, "Must be 3 characters at minimum")
  .max(128, "Must be 128 characters or less")
  .trim()
  .required();
const passportNumber = Yup.string()
  .min(9, "Must be 9 characters at minimum")
  .max(20, "Must be 20 characters or less")
  .trim()
  .required();

// Strong policy: at least 8 chars and all four character classes. The default
// password "Plus@1234" is rejected so users can't keep it.
const password = Yup.string()
  .min(8, "Must be 8 characters at minimum")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
    "Must include uppercase, lowercase, number, and special character"
  )
  .notOneOf(["Plus@1234"], "Please choose a different password")
  .required("Required");

// Login must accept the user's current (possibly weak/default) password so the
// backend can detect it and force a change.
const loginPassword = Yup.string().required("Required");

//for change Password
const oldPassword = Yup.string()
  .required("Required")
  .notOneOf([Yup.ref("password"), null], "Passwords must be different");

const confirmPassword = Yup.string()
  .required("Required")
  .oneOf([Yup.ref("password"), null], "Passwords must match");

export const registerCaptchaSchema = Yup.object({
  name,
  email,
  phone,
});
export const checkStatusCaptchaSchema = Yup.object({
  passportNumber,
});

export const registerSchema = Yup.object({
  name,
  email,
  password,
  confirmPassword,
});
export const loginSchema = Yup.object({
  email,
  password: loginPassword,
});
export const forgotSchema = Yup.object({
  email,
});
export const resetSchema = Yup.object({
  password,
  confirmPassword,
});
export const changePasswordSchema = Yup.object({
  oldPassword,
  password,
  confirmPassword,
});
export const profileUpdateSchema = Yup.object({});

// .matches(
//     "^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$",
//     "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
// )

// username: Yup.string()
//     .min(2, 'Must be 2 characters at minimum')
//     .max(20, 'Must be 20 characters or less')
//     .matches(/^[a-zA-Z0-9_]+$/, 'Invalid characters in username')
//     .required('Required'),
